// import _isEmail from "validator/lib/isEmail";
import{$}from"@olmokit/dom/$";/**
 * Validator: is email check
 */export default function isFilesize(element){let file=element.files?.[0];if(!file)return!0;let size=file.size,$file=$(".file"),sizeLimit=$(".fileSize",$file).value;return!(size>parseInt(sizeLimit))}